import {
  TRAINING_SUB_MENU_LIST,
  USERS_SUB_MENU_LIST,
  ACCOUNT_SUB_MENU_LIST,
  ANALYTICS_SUB_MENU_LIST,
  ASSETS_SUB_MENU_LIST,
  CALL_AI_SUB_MENU_LIST,
  DSR_SUB_MENU_LIST,
} from './enums';

export const TRAINING_SUB_MENU_REGEX_MAP = {
  [TRAINING_SUB_MENU_LIST.TRAINING_OVERVIEW]: [/\/ui\/training$/],
  [TRAINING_SUB_MENU_LIST.TRAINING_SERIES]: [/\/training\/programs/, /\/training\/program/],
  [TRAINING_SUB_MENU_LIST.TRAINING_MODULES]: [
    /\/training\/modules\//,
    /\/ui\/coaching\//,
    /\/ui\/reinforcement\//,
    /\/ui\/checklist\//,
    /\/admin\/update\//,
    /\/admin\/course\//,
    /\/admin\/assessment\//,
    /\/admin\/ilt\//,
  ],
  [TRAINING_SUB_MENU_LIST.TRAINING_ILT]: [/\/training\/ilt\//],
  [TRAINING_SUB_MENU_LIST.TRAINING_SERIES_OVERVIEW]: [
    /\/training\/series-overview\//,
    /\/training\/overview\//,
  ],
  [TRAINING_SUB_MENU_LIST.TRAINING_CERTIFICATIONS]: [
    /\/training\/manage-certificates/,
    /\/training\/certificates/,
  ],
  [TRAINING_SUB_MENU_LIST.TRAINING_TAGS]: [/\/training\/tags/],
  [TRAINING_SUB_MENU_LIST.TRAINING_MARKETPLACE]: [/\/training\/templates\//],
  [TRAINING_SUB_MENU_LIST.TRAINING_AI_TUTORIALS]: [/\/training\/tutorials\//],
};

export const ASSETS_SUB_MENU_REGEX_MAP = {
  [ASSETS_SUB_MENU_LIST.ASSETS_HUBS]: [/\/assets\/hubs/],
  [ASSETS_SUB_MENU_LIST.ASSETS_ASSETS]: [/\/ui\/assets\//],
  [ASSETS_SUB_MENU_LIST.ASSETS_ATTRIBUTES]: [/\/assets\/manage-attributes/],
  [ASSETS_SUB_MENU_LIST.ASSETS_HUBS_OVERVIEW]: [/\/assets\/hub-overview/],
};

export const CALL_AI_SUB_MENU_REGEX_MAP = {
  [CALL_AI_SUB_MENU_LIST.CALL_AI_LIBRARIES]: [
    /\/callai\/admin\/libraries/,
    /\/callai\/admin\/library/,
  ],
  [CALL_AI_SUB_MENU_LIST.CALL_AI_TRAINING_CALLS]: [/\/callai\/admin\/content-creation-recordings/],
};

export const DSR_SUB_MENU_REGEX_MAP = {
  [DSR_SUB_MENU_LIST.DSR_ROOMS]: [/\/dsr\/rooms/, /\/dsr\/room/],
  [DSR_SUB_MENU_LIST.DSR_TEMPLATES]: [/\/dsr\/templates/, /\/dsr\/room-template/],
  [DSR_SUB_MENU_LIST.DSR_INSIGHTS]: [/\/dsr\/insights/],
  [DSR_SUB_MENU_LIST.DSR_DEALS]: [/\/dsr\/more\//],
  [DSR_SUB_MENU_LIST.DSR_SETTINGS]: [/\/dsr\/settings\//],
};

export const ANALYTICS_SUB_MENU_REGEX_MAP = {
  [ANALYTICS_SUB_MENU_LIST.ANALYTICS_MY]: [
    /\/analytics\/my-analytics\//,
    /\/analytics\/custom-section\//,
    /\/analytics\/custom-created\//,
    /\/analytics\/widgets\/report\/.*dashboardCategoryPage=my-analytics/,
  ],
  [ANALYTICS_SUB_MENU_LIST.ANALYTICS_TRAINING]: [
    /\/analytics\/training/,
    /\/analytics\/series/,
    /\/analytics\/modules/,
    /\/analytics\/widgets\/report\/.*dashboardCategoryPage=training/,
  ],
  [ANALYTICS_SUB_MENU_LIST.ANALYTICS_USERS]: [
    /\/analytics\/users-and-roles/,
    /\/analytics\/new-rollup/,
  ],
  [ANALYTICS_SUB_MENU_LIST.ANALYTICS_ASSETS]: [
    /\/analytics\/assets/,
    /\/analytics\/widgets\/report\/.*dashboardCategoryPage=assets/,
  ],
  [ANALYTICS_SUB_MENU_LIST.ANALYTICS_CALL_AI]: [/\/analytics\/callai/],
  [ANALYTICS_SUB_MENU_LIST.ANALYTICS_COACHING]: [/\/analytics\/coaching/],
  [ANALYTICS_SUB_MENU_LIST.ANALYTICS_RI]: [/\/analytics\/ri-report/],
  [ANALYTICS_SUB_MENU_LIST.ANALYTICS_ORG_READINESS]: [/\/analytics\/wgll-readiness/],
  [ANALYTICS_SUB_MENU_LIST.ANALYTICS_COPILOT]: [/\/analytics\/copilot/],
};

export const USERS_SUB_MENU_REGEX_MAP = {
  [USERS_SUB_MENU_LIST.USERS_USERS]: [/\/ui\/users/, /\/admin\/user/],
  [USERS_SUB_MENU_LIST.USERS_GROUPS]: [/\/users\/groups/, /\/admin\/group\//],
  [USERS_SUB_MENU_LIST.USERS_PROFILE]: [/\/users\/profile-management/],
  [USERS_SUB_MENU_LIST.USERS_ROLES]: [/\/users\/roles/],
};

export const ACCOUNT_SUB_MENU_REGEX_MAP = {
  [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_HOMEPAGES]: [/\/pages\/adaptive/],
  [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_EMAIL]: [/\/account-settings\/email-templates/],
  [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_AUTO_SUITE]: [/\/admin\/automation-suite/],
  [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_INTEGRATIONS]: [/\/account\/settings\/integrations/],
  [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_CUSTOM_PROPERTIES]: [
    /\/account-settings\/custom-properties\//,
  ],
  [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_LOGS]: [/\/account-settings\/system-logs\//],
  [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_WGLL_LIBRARY]: [/\/account-settings\/wgll/],
  [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_ORG_CONTEXT]: [/\/account-settings\/org-context/],
  [ACCOUNT_SUB_MENU_LIST.ACCOUNT_SETTINGS_SETTINGS]: [/\/account-settings\/settings\//],
};

export const SUB_ADMIN_MENU_REGEX_MAP = {
  ...ASSETS_SUB_MENU_REGEX_MAP,
  ...CALL_AI_SUB_MENU_REGEX_MAP,
  ...DSR_SUB_MENU_REGEX_MAP,
  ...ANALYTICS_SUB_MENU_REGEX_MAP,
  ...USERS_SUB_MENU_REGEX_MAP,
  ...ACCOUNT_SUB_MENU_REGEX_MAP,
  ...TRAINING_SUB_MENU_REGEX_MAP,
};
